import React, { useCallback, useEffect, useState } from 'react'
import { useDrag, useDrop, DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { createPortal } from 'react-dom'
import { useHistory } from 'react-router-dom'

import Files from 'components/Files'
import File from 'components/File'

const DraggableFile = ({ isDragging, ...props }) => {
  const history = useHistory()
  const onDrop = useCallback((fileId, taskId) => {
    fetch(`/ordertask/addExistingFileToTask?fileId=${fileId}&taskId=${taskId}`, { method: 'POST' })
      .then((response) => response.json())
      .then((json) => {
        history.goBack()
      })
      .catch((err) => window.alert(err))
  }, [])

  const [{ opacity }, dragRef] = useDrag({
    item: { type: 'FILE', id: props.id },
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult()
      if (item && dropResult) {
        onDrop(item.id, dropResult.taskId)
      }
    },
    collect: (monitor) => ({
      opacity: monitor.isDragging() ? 0.5 : 1
    })
  })

  return (
    <div ref={dragRef} style={{ opacity }}>
      <File {...props} />
    </div>
  )
}

const DroppableArea = ({ taskId, ...props }) => {
  const history = useHistory()
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: 'FILE',
    drop: () => ({ taskId }),
    canDrop: () => true,
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
      canDrop: !!monitor.canDrop()
    })
  })

  return (
    <div className="fixed inset-0 transition-opacity" ref={drop} onClick={() => history.goBack()}>
      <div className={`absolute inset-0 bg-gray-300 ${isOver ? 'opacity-25' : 'opacity-50'}`}></div>
    </div>
  )
}

const OrderFilesPage = (props) => {
  const { match, location } = props
  const params = new URLSearchParams(location.search)

  if (!params.has('orderId') || !params.has('showOrderFiles') || !params.has('taskId')) {
    return null
  }

  return createPortal(
    <DndProvider backend={HTML5Backend}>
      <div className="fixed bottom-0 inset-x-0 p-4 sm:inset-0 sm:flex justify-end z-50">
        <DroppableArea taskId={params.get('taskId')} />
        <div className="bg-white rounded-sm overflow-hidden shadow transform transition-all w-full sm:w-1/3 md:1/4 max-w-screen-sm">
          <Files allowDelete={false} orderId={params.get('orderId')} FileComponent={DraggableFile} />
        </div>
      </div>
    </DndProvider>,

    document.getElementById("react_app_modal"),
  );
}


export default OrderFilesPage
